package com.eladfinish.bible.contest.screens.mikud.usecases

import com.eladfinish.bible.contest.extensions.ordinalIndexOf
import com.eladfinish.bible.contest.screens.mikud.MikudRepository
import io.github.aakira.napier.Napier
import kotlin.random.Random

class GetRandomBookRandomChapterFilenameUseCase(
    private val extractMikudListUseCase: ExtractMikudListUseCase,
) {

    operator fun invoke(mikudStr: String): String {
        Napier.d("mikudStr_\n$mikudStr")
        val bookNameAndChapters = pickRandomBookInMikudAndItsChapters(mikudStr)
        val result = pickRandomChapterFromList(bookNameAndChapters)
        val numberAndBookName = bookNameAndChapters.take(bookNameAndChapters.indexOf("-") + 1)
        val filename = "_$numberAndBookName$result.txt"
        Napier.d("getRandomBookRandomChapterFilename: $filename")
        return filename
    }

    private fun pickRandomChapterFromList(chapterList: String): String =
        extractMikudListUseCase(chapterList)
            .random()

    private fun pickRandomBookInMikudAndItsChapters(mikudStr: String): String {
        val numberOfBooks = mikudStr.length - mikudStr.replace(oldValue = MikudRepository.BOOK_SEPARATOR, newValue = "").length
        val randomBook = Random.Default
        val rb = randomBook.nextInt(numberOfBooks) + 1
        val indexStart = ordinalIndexOf(mikudStr, MikudRepository.BOOK_SEPARATOR, rb) + 1
        val indexEnd = mikudStr.indexOf("]", indexStart) + 1
        return mikudStr.substring(indexStart, indexEnd)
    }
}
